import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PokePricerApp from './PokePricerApp';
import reportWebVitals from './reportWebVitals';
import registerSW from './registerSW';
import { AuthProvider } from './shared/auth';

/* AuthProvider is a passthrough until a publishable key is configured, so with
   accounts off this is the same tree it has always been — no provider, no
   Clerk code running, nothing leaving the page. */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <PokePricerApp />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Offline support. Deliberately last: nothing above depends on it.
registerSW();
